import { $hasMenuOpen, $isVideoAutoplayable } from '../stores/state';

export default class VideoInline extends HTMLElement {
    static CALL_EVENT = 'onInview';

    constructor(m) {
        super(m);

        // Binding
        this.onMenuOpenChange = this.onMenuOpenChange.bind(this);
        this.onInview = this.onInview.bind(this);

        // UI
        this.$video = this.querySelector('video');

        // Data
        this.isInview = false;
        this.uid = this.dataset.uid;
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        window.addEventListener(`${VideoInline.CALL_EVENT}${this.uid}`, this.onInview);
        this.unbindMenuOpenListener = $hasMenuOpen.listen(this.onMenuOpenChange);
    }

    unbindEvents() {
        window.removeEventListener(`${VideoInline.CALL_EVENT}${this.uid}`, this.onInview);
        this.unbindMenuOpenListener?.();
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onMenuOpenChange(hasMenuOpen) {
        if (hasMenuOpen) {
            this.pause();
        } else {
            if (this.isInview) this.play();
        }
    }

    onInview(args) {
        const way = args.detail.way;

        if (way === 'enter' && !this.isInview) {
            this.$video.muted = true;
            this.play();
            this.isInview = true;
        } else if (way === 'leave' && this.isInview) {
            this.pause();
            this.isInview = false;
        }
    }

    // =============================================================================
    // Methods
    // =============================================================================
    async play() {
        try {
            if (this.$video.paused && $isVideoAutoplayable.value) {
                await this.$video.play();
                $isVideoAutoplayable.set(true);
            }
        } catch (err) {
            $isVideoAutoplayable.set(false);
        }
    }

    pause() {
        if (!this.$video.paused) this.$video.pause();
    }
}
